'use client';

import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';

interface ThemeProviderProps {}

export const ThemeProvider = ({
  children,
}: React.PropsWithChildren<ThemeProviderProps>) => {
  const theme = createTheme();
  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};
